import React, { FC, useEffect } from 'react';
import { FormControl, Checkbox, FormGroup, FormControlLabel, Box } from '@mui/material';
import WarrantyTypeDialog from '../warranty-type-dialog/warranty-type-dialog.component';
import { useTranslation } from 'react-i18next';

type WarrantyProps = {
    handleWarranty: (value: boolean, type: string) => void;
    warranty: boolean;
    warrantyType: string;
};

const Warranty: FC<WarrantyProps> = ({ handleWarranty, warranty, warrantyType }: WarrantyProps) => {
    const { t: translate } = useTranslation(['orders']);
    const [warrantyValue, setWarrantyValue] = React.useState(false);
    const [openWarrantyDialog, setOpenWarrantyDialog] = React.useState(false);

    useEffect(() => {
        setWarrantyValue(warranty || false);
    }, [warranty]);

    const handleChange = (_event: React.SyntheticEvent, checked: boolean) => {
        if (checked) {
            setOpenWarrantyDialog(true);
        } else {
            setWarrantyValue(false);
            warrantyType = 'NONE';
            handleWarranty(checked, warrantyType);
        }
    };

    const onConfirm = (type: string) => {
        setWarrantyValue(true);
        warrantyType = type;
        handleWarranty(true, type);
        setOpenWarrantyDialog(false);
    };

    const handleClose = () => {
        setOpenWarrantyDialog(false);
        setWarrantyValue(false);
        warrantyType = '';
    };

    return (
        <Box sx={{ marginLeft: 'auto', paddingLeft: '15px' }}>
            <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                    <FormControlLabel
                        value={warrantyValue}
                        onChange={handleChange}
                        control={<Checkbox color="secondary" checked={warrantyValue} data-test="warranty-checkbox" />}
                        label={
                            warrantyType && warrantyType !== 'NONE'
                                ? `${translate('orders:WARRANTY')} - ${translate(`orders:${warrantyType}`)}`
                                : translate('orders:WARRANTY')
                        }
                        labelPlacement="end"
                    />
                </FormGroup>
            </FormControl>
            <WarrantyTypeDialog
                open={openWarrantyDialog}
                handleConfirm={onConfirm}
                handleClose={handleClose}
                warrantyType={warrantyType}
            />
        </Box>
    );
};

export default Warranty;
